import React, {useState} from 'react';
import {Modal} from "../../../../../../components/modal/modal.jsx";
import Button from "../../../../../../components/button/button.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";

const API_URL = import.meta.env.VITE_API_URL;

const ModalRequester = ({open, setOpen, data, requester, password, setPassword, save, saveAssuming}) => {

    return (
        <Modal open={open} setOpen={setOpen} centered size="md" backdrop="static" keyboard={false} title={"Assinatura"} className={"w-4/12"}>
            <Modal.Body className="p-2">
                <div className="grid grid-cols-12 gap-4 items-center">
                    <div className="col-span-4">
                        <div className="image-effective">
                            <div className="p-1 bg-white border border-[#e0e0e0] rounded shadow h-[137px] overflow-hidden">
                                <img className={"h-full w-full object-contain"} src={`${API_URL}/user/getImage/${data.requester_id}`}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-8">
                        <p className="mb-1"><b>Almoxarife solicitante:</b></p>
                        <p className="mb-2">{requester}</p>
                        <InputForm
                            type={"password"}
                            id="password"
                            value={password}
                            label="Senha"
                            onChange={({target: {value}}) => setPassword(value)}/>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className={"p-1"}>
                <div className={"w-full flex justify-end gap-2"}>
                    <Button target={'secondary'} onClick={saveAssuming}>
                        Transferir sem a senha do solicitante
                    </Button>

                    <Button onClick={save} actionFeedbackType='save'>

                        Salvar
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalRequester;